<template>
    <router-view />
</template>
<script stc="./app.ts" lang="ts"></script>
<style lang="scss">

</style>
